import type { TFunction } from 'i18next';
import { formatTokenCount } from './model-limit-input.js';

interface ModelMetadata {
  capabilities: {
    vision?: boolean;
    documentInput?: boolean;
  };
  limits?: {
    contextWindow?: number;
    maxOutputTokens?: number;
  };
}

export function renderModelSpec(t: TFunction, model: ModelMetadata): string {
  return t('models.specSummary', {
    contextWindow: formatTokenCount(model.limits?.contextWindow),
    maxOutputTokens: formatTokenCount(model.limits?.maxOutputTokens)
  });
}

export function visibleCapabilityKeys(model: ModelMetadata): Array<'vision' | 'documentInput'> {
  const keys: Array<'vision' | 'documentInput'> = [];
  if (model.capabilities.vision) keys.push('vision');
  if (model.capabilities.documentInput === true) keys.push('documentInput');
  return keys;
}

export function renderCapabilityBadges(t: TFunction, model: ModelMetadata) {
  const keys = visibleCapabilityKeys(model);
  if (keys.length === 0) return null;

  return (
    <span className="badge-group capability-badges">
      {keys.map((key) => (
        <span key={key} className="badge active">
          {t(key === 'vision' ? 'models.capVision' : 'models.capDocumentInput')}
        </span>
      ))}
    </span>
  );
}
